function s(i) {
  return function(e, l, f) {
    for (var u = -1, r = Object(e), a = f(e), n = a.length; n--; ) {
      var t = a[i ? n : ++u];
      if (l(r[t], t, r) === !1)
        break;
    }
    return e;
  };
}
export {
  s as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_createBaseFor.js
// module id = 1462
// module chunks = 41